import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { catchError, of, tap } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../features/login/services/auth';
import { AuthActions } from '../state/auth/auth.actions';

@Injectable({ providedIn: 'root' })
export class SessionInitializerService {
  private store = inject(Store);
  private authService = inject(AuthService);

  initialize(): Promise<void> {
    return firstValueFrom(
      this.authService.userMe().pipe(
        tap((user) => this.store.dispatch(AuthActions.loginSuccess(user))),
        catchError(() => of(null)),
      ),
    ).then(() => undefined);
  }
}

export function initializeSession(sessionService: SessionInitializerService) {
  return () => sessionService.initialize();
}
